import kebabCase from 'lodash/kebabCase';
export var createPerformanceTab = function createPerformanceTab(label) {
  return {
    key: kebabCase(label),
    label: label
  };
};
export var PERFORMANCE_TAB_CHANNELS = createPerformanceTab('Channels');
export var PERFORMANCE_TAB_INVENTORY = createPerformanceTab('Inventory');
export var PERFORMANCE_TABS = [PERFORMANCE_TAB_CHANNELS, PERFORMANCE_TAB_INVENTORY];